import type { FC } from 'react'
import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { RitualMonoLogo } from '@segment/matcha/components/CompanyLogos/CompanyMono'

import TestimonialBase, * as Testimonial from '@segment/matcha/recipes/Testimonial'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  description: `“The biggest thing Segment CDP has given us is flexibility. We’re able to focus on the most optimal journey and know that it will be possible; any experience we want for our customers we can deliver downstream to them.”`,
  author: `Laura Brodie`,
  role: `Director of Customer Lifecycle and Growth`,
}

const TestimonialComponent: FC = () => {
  const theme = useTheme()
  return (
    <StyledSectionBase variant="centered">
      <Section.Contents>
        <TestimonialBase variant="base">
          <Testimonial.Base height="auto">
            <Testimonial.BaseContentSlot>
              <Testimonial.BaseLogo>
                <RitualMonoLogo color={`${theme.palette.neutrals.white[`100`]}`} />
              </Testimonial.BaseLogo>
              <Testimonial.BaseText>{copy.description}</Testimonial.BaseText>
            </Testimonial.BaseContentSlot>
            <Testimonial.BaseAuthorSlot>
              <Testimonial.AuthorInfo>
                <Testimonial.AuthorName>{copy.author}</Testimonial.AuthorName>
                <Testimonial.AuthorPosition>{copy.role}</Testimonial.AuthorPosition>
              </Testimonial.AuthorInfo>
            </Testimonial.BaseAuthorSlot>
          </Testimonial.Base>
        </TestimonialBase>
      </Section.Contents>
    </StyledSectionBase>
  )
}

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    row-gap: 0;
    ${Section.Contents} {
      max-width: 900px;
    }
  }
`

export default TestimonialComponent
